import { ApiBaseService } from 'api/apibase.service';
import { AxiosPromise } from 'axios';
import { HomePageContent } from 'components/Home/types';

class HomePageApiService extends ApiBaseService {
  getContent(
    previewDate: string | null,
    showDraft: string | null,
  ): AxiosPromise<HomePageContent> {
    return this.apibase.get<HomePageContent>('/home', {
      params: {
        previewDate,
        showDraft,
      },
    });
  }
}

export const homePageApiService = new HomePageApiService();
